// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"58205a16","664":"6c2b8813"}[chunkId] + ".chunk.css";
};